import restaurant from "../Reducers/data/restaurant.json";
import axios from "axios";
const Documenu = require('documenu')
Documenu.configure('2819d56d5a2933d849fe489b804c8ebd')

const URL = '  https://food-mafia-server.herokuapp.com/api/details';
// const EXTURL = 'https://api.documenu.com/v2/restaurant/4072702673999819?key=eb12d93b695847acfe7f2ec50ca6813f';

export const bookmark = (userId, restaurantId, bookmark_state) => {
    let data = {user_id : userId, restaurant_id: restaurantId, bookmark_state: bookmark_state}
    return fetch(URL+'/bookmark', {
        method: 'POST',
        body: JSON.stringify(data),
        headers: {
            'content-type': 'application/json'
        }
    }).then(response => response.json());
}
export const getBookmarks = (dispatch,userId, restaurantId) => {
    if(!userId || userId === '') {
        return
    }
    let fullUrl = URL+'/bookmark/'+userId+"/"+restaurantId;
    axios.get(fullUrl).then( res => {
            dispatch({
                type: "get-bookmarks",
                bookmark: [...res.data],
            })
        }
    )
}
export const addItems = (restaurantId, data) => {
    let details = {restaurantId: restaurantId, data: [...data]}
    return fetch(URL+'/'+restaurantId, {
        method: 'POST',
        body: JSON.stringify(details),
        headers: {
            'content-type': 'application/json'
        }
    }).then(response => {
        console.log( response.json())
        return response.json()
    });
}

export const createRestaurant = (userId, data) => {
    return fetch(URL+'/business/'+userId, {
        method: 'POST',
        body: JSON.stringify({...data}),
        headers: {
            'content-type': 'application/json'
        }
    }).then(response => {
        return response.json()
    });
}
export const getRestaurant = (dispatch, restaurantId) => {
    console.log(restaurantId)

    axios.get(URL+'/local/'+restaurantId).then(res =>{
        console.log(URL+'/local/'+restaurantId)
        if(res.data){
            dispatch({
               type: "get-restaurant",
               restaurant: {...res.data},
           })
        }else{
        Documenu.Restaurants.get(restaurantId)
            .then(res=> {
                console.log("res.result")
                console.log(res.result)
                dispatch({
                    type: "get-restaurant",
                    restaurant: {...res.result},
                })
            });
        }
    })
     // fetch(URL+'/'+restaurantId)
     //    .then((response) => {
     //        dispatch({
     //            type: "get-restaurant",
     //            restaurant: {...response.json()},
     //        })
     //    })
     //    .then((res) =>{
     //        if(res){
     //            dispatch({
     //                type: "get-restaurant",
     //                restaurant: {...res},
     //            })
     //        }
     //    });

}


export default {
    bookmark,addItems, getBookmarks, createRestaurant
}